import React from 'react';

const NoElectricity = props => (
  <svg
    width={38}
    height={38}
    viewBox="0 0 38 38"
    preserveAspectRatio="xMidYMid"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="m26.9 17.438-11.141 16.56 2.23-10.645H9.076L20.218 6.796l-2.23 10.643 8.911-.001Z"
      stroke="#BCC6CA"
      strokeLinejoin="round"
    />
    <path d="M4.313 34 33.96 4" stroke="#647A85" strokeWidth={5.04} strokeLinecap="square" />
    <path d="M4.313 34 33.96 4" stroke="#BCC6CA" strokeLinecap="square" />
  </svg>
);

export default NoElectricity;
